import React, { ReactElement } from 'react';
import {
  Link, Col, Row, Text,
} from 'idsk-react-components';
import './legislativnyMaterialDetailRow.scss';
import PredpisZbierky from '../../../../../../model/legislativnyMaterial/PredpisZbierky';

interface Props {
  label: string,
  data: PredpisZbierky | PredpisZbierky[];
}

const NovelizovanyPredpis = ({
  label,
  data,
}: Props): ReactElement => {
  const renderLink = (popis: string, redirectUrl: string): ReactElement => (
    <>
      <Link
        className="novelizovany-predpis-link"
        to={`${process.env.REACT_APP_PORTAL_MAIN_URL}${redirectUrl}`}
        target="_top"
      >
        {popis}
      </Link>
    </>
  );

  if (Array.isArray(data)) {
    if (data.length === 1) {
      return (
        <Row className="material-detail-row">
          <Col width="one-third">
            <Text type="span" className="information-header">{label}</Text>
          </Col>
          <Col width="two-thirds">
            <Text type="p" className="material-detail-row-text">{data[0].menovka}</Text>
            {renderLink(data[0]?.popis, data[0]?.redirectUrl)}
          </Col>
        </Row>
      );
    }

    if (data.length === 0) {
      return (<></>);
    }

    return (
      <Row className="material-detail-row">
        <Col width="one-third">
          <Text type="span" className="information-header">{label}</Text>
        </Col>
        <Col width="two-thirds">
          <Text type="ul">
            {data.map((dataRecord) => (
              <Text
                type="li"
                key={dataRecord.iri}
              >{dataRecord.menovka} <br />
                <div className="suvisiaci-proces-list-li">
                  {renderLink(dataRecord?.popis, dataRecord?.redirectUrl)}
                </div>
              </Text>
            ))}
          </Text>
        </Col>
      </Row>
    );
  }

  return data ? (
    <Row className="material-detail-row">
      <Col width="one-third">
        <Text type="span" className="information-header">{label}</Text>
      </Col>
      <Col width="two-thirds">
        <Text type="p" className="material-detail-row-text">{data.menovka}</Text>
        {renderLink(data?.popis, data?.redirectUrl)}
      </Col>
    </Row>
  ) : <></>;
};

export default NovelizovanyPredpis;
